import React, { useState } from "react";
import { useCookiePreference } from "../hooks/useCookiePreference";

//devextreme components
import Switch from 'devextreme-react/switch';
import Button from 'devextreme-react/button';

//component styles
import classes from "./CookieConsent.module.scss";

function CookieConsent(props) {
  const { closeNotice } = props;
  const cookiesEnabled = navigator.cookieEnabled;

  const [allowRememberLogin_] = useCookiePreference("COOKIEPREF_ALLOWREMEMBERLOGIN");
  const [allowSocialLogin_] = useCookiePreference("COOKIEPREF_ALLOWSOCIALLOGIN");
  const [allowRememberLogin, setAllowRememberLogin] = useState(allowRememberLogin_);
  const [allowSocialLogin, setAllowSocialLogin] = useState(allowSocialLogin_);

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.title}>Cookie Einstellungen</div>
        Wir versuchen möglichst ohne Cookies auszukommen. <br />
        Um die Benutzererfahrung zu verbessern, können Sie dennoch <br />
        verschiedene Cookies zulassen.<br />
        <div className={classes.seperator} />
        {cookiesEnabled
          ? (
            <div className={classes.cookieList}>
              <div>
                <Switch
                  id="allowRememberLogin"
                  value={allowRememberLogin}
                  onValueChanged={(e) => setAllowRememberLogin(e.value)}
                />
                <p>Cookie erlauben um angemeldet zu bleiben</p>
              </div>
              <div>
                <Switch
                  id="allowSocialLogin"
                  value={allowSocialLogin}
                  onValueChanged={(e) => setAllowSocialLogin(e.value)}
                />
                <p>
                  Cookies von externen Anmeldeanbietern erlauben
                </p>
              </div>
            </div>
          )
          : "Leider verhindern ihre Browsereinstellungen das Setzen von Cookies"
        }
      </div>
      <div className={classes.actions}>
        <Button
          width="100%"
          onClick={() => closeNotice({ allowRememberLogin: allowRememberLogin, allowSocialLogin: allowSocialLogin })}
          text="Cookie Einstellungen speichern"
        />
      </div>
    </div>
  );
}

export default (CookieConsent);